import React from 'react';
import Typography from '@mui/material/Typography';
import * as _R from 'ramda';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import FormHelperText from '@mui/material/FormHelperText';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {DialogBoxMedium} from '../../common/dialog.medium';
import { CustomMaterialTable } from '../../common/CustomMaterialTable';
import { CustomizedSnackbars } from '../../common/snackbars';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

const gridStyle = {
    margin: '15px 0px'
};
function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <Typography
            component="div"
            role="tabpanel"
            className="tab-panel"
            hidden={value !== index}
            {...other}
        >
            {children}
        </Typography>
    );
}
export const InstanceDetailsComponent = (props) => {
    const [tabValue, setTabValue] = React.useState(0);
    const tabChange = (event, newValue) => {
        setTabValue(newValue);
    };
    return (
        <>
            <Paper md={12}>
                <div class="p1">
                    <div className={'section-main'}>
                        <div className={'listSubHeader'}>
                            <Typography component="h2" className={'section-title'} variant="button" display="block" gutterBottom color="primary">{props.DestinationInstance} Instance </Typography>
                        </div>
                        <div className={'tab-navContainer d-flex justify-between steps-tab'}>
                            <Tabs
                                value={tabValue}
                                onChange={tabChange}
                                indicatorColor="primary"
                                aria-label="Instance sync Tabs"
                            >
                                {props.StaffView && <Tab label="Users" />}
                                {props.LocationView && <Tab label="Location" />}

                            </Tabs>
                        </div>
                        {props.StaffView &&
                            <TabPanel value={tabValue} index={0}>
                                <form className="form-fullwidth" method="post">
                                    {props.StaffEdit &&
                                    <Grid container spacing={3} style={gridStyle}>
                                            <Grid item xs={12} sm={6} md={3} lg={2} className='justify-between'>
                                                <FormControl variant="standard" fullWidth>
                                                    <Autocomplete
                                                        value={
                                                            props.SourceUserList?.find(
                                                                x => x.user_id === props.FormFields.src_user
                                                            ) || null
                                                        }
                                                        onChange={(e, newValue) => {
                                                            props.HandleOnChange({
                                                                target: {
                                                                    name: "src_user",
                                                                    value: newValue ? newValue.user_id : ""
                                                                }
                                                            });
                                                        }}
                                                        options={props.SourceUserList || []}
                                                        getOptionLabel={(option) =>
                                                            option ? option.full_name : ""
                                                        }
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="standard"
                                                                label="Source User"
                                                                required
                                                                error={Boolean(props.Errors?.src_user)}
                                                                helperText={props.Errors?.src_user || ""}
                                                            />
                                                        )}
                                                        noOptionsText="No matching user"
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={6} md={3} lg={2} className='justify-between'>
                                                <FormControl variant="standard" fullWidth>
                                                    <Autocomplete
                                                        value={
                                                            props.DestinationUserList?.find(
                                                                x => x.user_id === props.FormFields.dest_user
                                                            ) || null
                                                        }
                                                        onChange={(e, newValue) => {
                                                            props.HandleOnChange({
                                                                target: {
                                                                    name: "dest_user",
                                                                    value: newValue ? newValue.user_id : ""
                                                                }
                                                            });
                                                        }}
                                                        options={props.DestinationUserList || []}
                                                        getOptionLabel={(option) =>
                                                            option ? option.user_fullname : ""
                                                        }
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="standard"
                                                                label="Destination User"
                                                                required
                                                                error={Boolean(props.Errors?.dest_user)}
                                                                helperText={props.Errors?.dest_user || ""}
                                                            />
                                                        )}
                                                        noOptionsText="No matching user"
                                                    />
                                                </FormControl>
                                            </Grid>

                                        <Grid item>
                                            <Button variant="contained" size="small" color="primary" onClick={() => { props.HandleSubmit('user') }}> Add </Button>
                                        </Grid>
                                    </Grid>
                                    }
                                    <React.Fragment>
                                        <div className={'mtable-basic'}>
                                            <CustomMaterialTable
                                                title=" "
                                                columns={[
                                                    {
                                                        title: 'Source User',
                                                        field: 'src_full_name',
                                                    },
                                                    {
                                                        title: 'Destination User',
                                                        field: 'dest_full_name',
                                                    },
                                                ]}
                                                data={props.UserMapped}
                                                options={{
                                                    search: false,
                                                    actionsColumnIndex: -1,
                                                    toolbar: true,
                                                    pageSizeOptions: [10, 20, 30],
                                                    rowStyle: rowData => ({
                                                        color: (typeof rowData.isDataChanged !== 'undefined' && rowData.isDataChanged) ? '#DC143C' : '',
                                                    })
                                                }}
                                                actions={[
                                                    {
                                                        icon: 'visibility',
                                                        tooltip: 'View',
                                                        onClick: (event, rowData) => {
                                                            props.OnView(rowData['id']);
                                                        },
                                                    },
                                                    ...(props.StaffEdit ? [{
                                                        icon: 'delete',
                                                        tooltip: 'Delete',
                                                        onClick: (event, rowData) => {
                                                            props.OnDeleteStaff(rowData['id'], rowData['src_full_name'], 'staff');
                                                        },
                                                    }] : [])
                                                ]}
                                            />
                                        </div>
                                    </React.Fragment>
                                </form>
                            </TabPanel>
                        }
                        {props.LocationView &&
                            <TabPanel value={tabValue} index={props.StaffView ? 1 : 0}>
                                <form className="form-fullwidth" method="post">
                                    {props.LocationEdit &&
                                    <Grid container spacing={3} style={gridStyle}>
                                        <Grid item xs={12} sm={6} md={3} lg={2} className='justify-between'>
                                            <FormControl variant="standard">
                                                <InputLabel htmlFor="source_location">Source Location</InputLabel>
                                                <Select
                                                value={props.FormFields.src_location}
                                                    onChange={props.HandleOnChange}
                                                    inputProps={{
                                                        name: 'src_location',
                                                        id: 'src_location',
                                                    }}>
                                                    <MenuItem value='0'>-Select Location-</MenuItem>
                                                {typeof props.SourceLocationList != 'undefined' && props.SourceLocationList !== null && props.SourceLocationList.map((t, i) =>
                                                        <MenuItem value={t.id} key={'st-' + i}>{t.location}</MenuItem>
                                                    )}
                                                </Select>
                                            {props.Errors.src_location && <FormHelperText className='error' >{props.Errors.src_location}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={2} className='justify-between'>
                                            <FormControl variant="standard">
                                                <InputLabel htmlFor="group">Destination Location</InputLabel>
                                                <Select
                                                    value={props.FormFields.dest_location}
                                                    onChange={props.HandleOnChange}
                                                    inputProps={{
                                                        name: 'dest_location',
                                                        id: 'dest_location',
                                                    }}>
                                                    <MenuItem value='0'>-Select Location-</MenuItem>
                                                {typeof props.DestinationLocationList != 'undefined' && props.DestinationLocationList !== null && props.DestinationLocationList.map((t, i) =>
                                                        <MenuItem value={t.id} key={'st-' + i}>{t.location}</MenuItem>
                                                    )}
                                                </Select>
                                                {props.Errors.dest_location && <FormHelperText className='error' >{props.Errors.dest_location}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                        <Grid item>
                                            <Button variant="contained" size="small" color="primary" onClick={() => { props.HandleSubmit('location') }}> Add </Button>
                                        </Grid>
                                    </Grid>
                                    }
                                </form>
                            <div className={'mtable-basic'}>
                                <CustomMaterialTable
                                    title=" "
                                    columns={[
                                        {
                                            title: 'Source Location',
                                            field: 'source_location_name',
                                        },
                                        {
                                            title: 'Destination Location',
                                            field: 'destination_location_name',
                                        },

                                    ]}
                                    data={props.LocationMapped}
                                    options={{
                                        search: false,
                                        actionsColumnIndex: -1,
                                        toolbar: true,
                                        pageSizeOptions: [10, 20, 30],
                                        rowStyle: rowData => ({
                                            color: (typeof rowData.isDataChanged !== 'undefined' && rowData.isDataChanged) ? '#DC143C' : '',
                                        })
                                    }}
                                    actions = { props.LocationEdit ? [
                                        {
                                            icon: 'delete',
                                            tooltip: 'Delete',
                                            onClick: (event, rowData) => {
                                                props.OnDeleteLocation(rowData['id'], rowData['source_location_name'], 'location');
                                            },
                                        }
                                    ]:
                                    []
                                }
                                />
                            </div>
                            </TabPanel>
                        }                        
                    </div>
                </div>
            </Paper>
            {props.SnackbarOpen &&
                <CustomizedSnackbars
                    open={props.SnackbarOpen}
                    variant={props.SnackbarVariant}
                    message={props.SnackbarMsg}
                    handleClose={props.SnackbarClose}
                />
            }
            {props.StaffDelete &&
                <DialogBoxMedium
                    Open = {props.StaffDelete}
                    Cancel = {props.Close}
                    Title = { "Delete User"}
                    OnSubmit={() => props.Delete()}
                    ButtonName={'Delete'}
                    Content={"Do you want to delete the user mapping for " +(props.SrcFullName) +" ?"}
                />
            }
            {props.LocationDelete &&
                <DialogBoxMedium
                    Open = {props.LocationDelete}
                    Cancel = {props.Close}
                    Title = { "Delete Location"}
                    OnSubmit={() => props.Delete()}
                    ButtonName={'Delete'}
                    Content={"Do you want to delete the location mapping for " +(props.SourceLocationName) +" ?"}
                />
            }
        </>
    )
}
const DialogContent = (p) => {
    const {FormProps:props} = p;
    return (
        <form className="form-fullwidth">
                <Grid item xs={12} md={12} className='justify-between'>
                    <FormControl variant="standard">
                        <InputLabel htmlFor="group">Source Task </InputLabel>
                        <Select
                            value={props.FormFields.editSrcTask}
                            onChange={props.HandleOnChange}
                            inputProps={{
                                name: 'editSrcTask',
                                id: 'editSrcTask',
                            }}>
                            <MenuItem value='0'>-Select task-</MenuItem>
                            {typeof props.EditSrcTaskList != 'undefined' && props.EditSrcTaskList !== null && props.EditSrcTaskList.map((t, i) =>
                                <MenuItem value={t.task_id} key={'st-' + i} disabled={t.task_status_name != 'Active'}>{t.task_path} ({t.task_status_name})</MenuItem>
                            )}
                        </Select>
                        {/* {props.Errors.src_task && <FormHelperText className='error' >{props.Errors.src_task}</FormHelperText>} */}
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={12} className='justify-between'>
                    <FormControl variant="standard">
                        <InputLabel htmlFor="group">Destination Task </InputLabel>
                        <Select
                            value={props.FormFields.editDestTask}
                            onChange={props.HandleOnChange}
                            inputProps={{
                                name: 'editDestTask',
                                id: 'editDestTask',
                            }}>
                            <MenuItem value='0'>-Select task-</MenuItem>
                            {typeof props.EditDestTaskList != 'undefined' && props.EditDestTaskList !== null && props.EditDestTaskList.map((t, i) =>
                                <MenuItem value={t.task_id} key={'st-' + i} disabled={t.task_status_name != 'Active'}>{t.task_path} ({t.task_status_name})</MenuItem>
                            )}
                        </Select>
                        {/* {props.Errors.src_task && <FormHelperText className='error' >{props.Errors.src_task}</FormHelperText>} */}
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={12}>
                <FormControl variant="standard">
                <InputLabel htmlFor="status">Sync Status</InputLabel>
                <Select
                    value={props.EditStatus}onChange={props.HandleStatusChange}
                    inputProps={{
                        name: 'status',
                        id: 'status',
                    }}>
                    <MenuItem value={1}>Active</MenuItem>
                    <MenuItem value={0}>Inactive</MenuItem>
                    </Select>
                    </FormControl>
                    </Grid>
        </form>
    )
}
